"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LowFaceWholeLife = exports.RiderConstants = exports.BenefitType = exports.RiderType = exports.PropertiesForECP = exports.PropertiesForWoP = exports.FrequencyUnit = exports.TimeFrequency = exports.Product = exports.productSpecs = exports.productTypes = void 0;
var _ = require("lodash");
var ChannelCodes_1 = require("./ChannelCodes");
var branding = {
    Valora: {
        name: 'Term Life',
        code: 'Valora'
    },
    Haven: {
        name: 'Haven',
        code: 'Haven'
    },
    MM: {
        name: 'MassMutual',
        code: 'MM'
    },
    CAS: {
        name: 'MassMutual'
    },
    LifeBridge: {
        name: 'MassMutual'
    },
    HealthBridge: {
        name: 'MassMutual'
    },
    AgeUp: {
        name: 'AgeUp',
        code: 'AU'
    }
};
var carrier = {
    HAVE: {
        name: 'MassMutual',
        code: 'HAVE'
    },
    CAS: {
        name: 'MassMutual',
        code: 'CAS'
    },
    CMLIFE: {
        name: 'CMLife',
        code: 'CMLIFE'
    },
    AGEUP: {
        name: 'MassMutual',
        code: 'AGEUP'
    }
};
var channelGroups = {
    HIT: {
        name: 'HIT'
    },
    MM: {
        name: 'MM'
    }
};
var channels = {
    Haven: {
        code: 'Haven',
        name: 'Haven Life',
        emailBranding: branding.Haven,
        carrier: carrier.HAVE,
        fromEmail: 'no-reply@havenlife.com',
        helpEmail: 'help@havenlife.com',
        phone: '1-855-744-2836',
        policyPhone: '1-855-744-2836',
        homeOfficeAddress: '100 Bright Meadow Blvd., Enfield, CT 06082',
        adminOfficeAddress: '60 Madison Ave., 7th Floor, New York, NY 10010',
        group: channelGroups.HIT,
        productCodes: {
            HavenTerm: 'HavenTerm',
            HavenTermSI: 'HavenTermSI'
        },
        productTypes: {}
    },
    Valora: {
        code: 'Valora',
        name: 'ValoraLife',
        emailBranding: branding.Valora,
        carrier: carrier.HAVE,
        fromEmail: 'no-reply@valoralife.com',
        helpEmail: 'help@valoralife.com',
        phone: '1-855-220-2333',
        policyPhone: '1-844-768-6774',
        group: channelGroups.HIT,
        productCodes: {
            ValoraTerm: 'ValoraTerm',
            ValoraROP: 'ValoraROP'
        },
        productTypes: {}
    },
    CAS: {
        code: 'CAS',
        name: 'MassMutual',
        emailBranding: branding.MM,
        carrier: carrier.CAS,
        fromEmail: 'no-reply@coverpath.com',
        helpEmail: 'help@coverpath.com',
        phone: '1-866-618-7797',
        policyPhone: '1-844-768-6774',
        group: channelGroups.HIT,
        productCodes: {
            CASTerm: 'CASTerm',
            CASTermECP: 'CASTermECP',
            CPL100: 'CPL100',
            CPL100A: 'CPL100A',
            CPL65: 'CPL65',
            CPL65A: 'CPL65A',
            CPL10: 'CPL10',
            CPL10A: 'CPL10A',
            CPL12: 'CPL12',
            CPL15: 'CPL15',
            CPL15A: 'CPL15A',
            CPL20: 'CPL20',
            CPL20A: 'CPL20A',
        },
        productTypes: {}
    },
    RMM: {
        code: 'RMM',
        name: 'RMM',
        emailBranding: branding.MM,
        carrier: carrier.HAVE,
        helpEmail: '',
        phone: '',
        policyPhone: '',
        group: channelGroups.HIT,
        productCodes: {
            RMMTerm: 'RMMTerm'
        },
        productTypes: {}
    },
    MMDirect: {
        code: 'MMDirect',
        name: 'MMDirect',
        emailBranding: branding.MM,
        carrier: carrier.CAS,
        fromEmail: 'no-replyDirectTerm@massmutual.com',
        helpEmail: 'supportDirectTerm@massmutual.com',
        phone: '1-844-611-1027',
        policyPhone: '1-844-768-6774',
        group: channelGroups.HIT,
        productCodes: {
            MMDirectTerm: 'MMDirectTerm',
            MMDirectTermECP: 'MMDirectTermECP'
        },
        productTypes: {}
    },
    LifeBridge: {
        code: 'LifeBridge',
        name: 'LifeBridge',
        emailBranding: branding.MM,
        carrier: carrier.CAS,
        fromEmail: 'no-replyDirectTerm@massmutual.com',
        helpEmail: 'supportDirectTerm@massmutual.com',
        phone: '1-844-611-1027',
        policyPhone: '1-844-768-6774',
        group: channelGroups.HIT,
        productCodes: {
            ET10: 'ET10'
        },
        productTypes: {}
    },
    AgeUp: {
        code: 'AgeUp',
        name: 'AgeUp',
        emailBranding: branding.AgeUp,
        carrier: carrier.AGEUP,
        fromEmail: 'no-reply@age-up.com',
        helpEmail: 'help@age-up.com',
        phone: '1-888-452-4387',
        policyPhone: '1-888-452-4387',
        group: channelGroups.HIT,
        productCodes: {
            AgeUp: 'AgeUpDIA'
        },
        productTypes: {
            DIA: 'DIA'
        }
    },
    HealthBridge: {
        code: 'HealthBridge',
        name: 'HealthBridge',
        emailBranding: branding.MM,
        carrier: carrier.CAS,
        fromEmail: 'no-replyDirectTerm@massmutual.com',
        helpEmail: 'supportDirectTerm@massmutual.com',
        phone: '1-812-496-2956',
        policyPhone: '1-812-496-2956',
        group: channelGroups.HIT,
        productCodes: {
            ET03: 'ET03'
        },
        productTypes: {}
    }
};
var productGroups = {
    LIFE: {
        name: 'LIFE'
    },
    DI: {
        name: 'Life DI'
    }
};
exports.productTypes = {
    ConvertTerm: {
        code: 'ConvertTerm',
        name: 'Convertible Term',
        group: productGroups.LIFE,
        productCodes: {}
    },
    Term: {
        code: 'Term',
        name: 'Term Life',
        group: productGroups.LIFE,
        productCodes: {
            HavenTerm: 'HavenTerm',
            HavenTermSI: 'HavenTermSI',
            ValoraTerm: 'ValoraTerm',
            CASTerm: 'CASTerm',
            CASTermECP: 'CASTermECP',
            MMDirectTerm: 'MMDirectTerm',
            MMDirectTermECP: 'MMDirectTermECP',
            ET10: 'ET10',
            RMMTerm: 'RMMTerm'
        }
    },
    Whole: {
        code: 'Whole',
        name: 'Whole Life',
        group: productGroups.LIFE,
        productCodes: {
            CPL100: 'CPL100',
            CPL100A: 'CPL100A',
            CPL65: 'CPL65',
            CPL65A: 'CPL65A',
            CPL10: 'CPL10',
            CPL10A: 'CPL10A',
            CPL12: 'CPL12',
            CPL15: 'CPL15',
            CPL15A: 'CPL15A',
            CPL20: 'CPL20',
            CPL20A: 'CPL20A'
        },
        productNames: {
            CPL100: 'Whole Life 100',
            CPL100A: 'Whole Life 100',
            CPL65: 'Whole Life 65',
            CPL65A: 'Whole Life 65',
            CPL10: 'Whole Life 10',
            CPL10A: 'Whole Life 10',
            CPL12: 'Whole Life 12',
            CPL15: 'Whole Life 15',
            CPL15A: 'Whole Life 15',
            CPL20: 'Whole Life 20',
            CPL20A: 'Whole Life 20'
        }
    },
    ROP: {
        code: 'ROP',
        name: 'Return of Premium',
        group: productGroups.LIFE,
        productCodes: {
            ValoraROP: 'ValoraROP'
        }
    },
    DI: {
        code: 'DI',
        name: 'Disability',
        group: productGroups.DI,
        productCodes: {
            MMDI: 'MMDI'
        }
    }
};
var productCodes = {};
productCodes[ChannelCodes_1.ChannelCodes.Haven] = {
    Term: 'Haven Term',
    HavenTermSI: 'Haven Term SI'
};
productCodes[ChannelCodes_1.ChannelCodes.Valora] = {
    Term: 'Valora Term',
    Rop: 'Valora ROP'
};
productCodes[ChannelCodes_1.ChannelCodes.CAS] = {
    Term: 'CAS Term',
    WholeLife: 'Coverpath Whole'
};
productCodes[ChannelCodes_1.ChannelCodes.MM] = {
    Term: 'MM Term'
};
productCodes[ChannelCodes_1.ChannelCodes.LifeBridge] = {
    Term: 'ET10'
};
productCodes[ChannelCodes_1.ChannelCodes.HealthBridge] = {
    Term: 'ET03'
};
productCodes[ChannelCodes_1.ChannelCodes.RMM] = {
    Term: 'RMM Term'
};
var policyRanges = {
    HavenTerm: {
        start: 1100000001,
        end: 110025e4
    },
    HavenTermSI: {
        start: 410000000,
        end: 410999999
    },
    ValoraTerm: {
        start: 1101000001,
        end: 1101999999
    },
    ValoraROP: {
        start: 1102000001,
        end: 1102999999
    },
    CASTerm: {
        start: 400000000,
        end: 400999999
    },
    CASTermECP: {
        start: 403000000,
        end: 403499999
    },
    MMDirectTerm: {
        start: 1100600001,
        end: 1100999999
    },
    MMDirectTermECP: {
        start: 404000000,
        end: 404999999
    },
    ET10: {
        start: 406000000,
        end: 406999999
    },
    ET03: {
        start: 406100000,
        end: 406999999
    },
    CPL100: {
        start: 402000000,
        end: 402999999
    },
    CPL65: {
        start: 405000000,
        end: 405999999
    },
    CPL10: {
        start: 408000000,
        end: 408499999
    },
    CPL12: {
        start: 408500000,
        end: 408999999
    },
    CPL15: {
        start: 409000000,
        end: 409499999
    },
    CPL20: {
        start: 409500000,
        end: 409999999
    },
    RMMTerm: {
        start: 0,
        end: 0
    }
};
var cpTermMinAge = 17.5;
exports.productSpecs = {
    HavenTermSI: {
        minFace: 25e3,
        maxFace: 5e5,
        maxFaceForHigherAge: 5e5,
        minAge: 18,
        maxAge: 64,
        maxAgeForHigherTerm: 49,
        tableRatingsEnabled: true,
        highTerm: 30,
        term: [10, 15, 20, 30],
        availableFaceAmountOptions: (function () {
            var options = [];
            for (var face = 25e3; face < 50e3; face += 5e3) {
                options.push(face);
            }
            for (var face = 50e3; face <= 5e5; face += 25e3) {
                options.push(face);
            }
            return options;
        })()
    },
    HavenTerm: {
        minFace: 1e5,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForTLIC: 1e6,
        maxFaceForNoncitizens: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        maxFaceForITM: 3e5,
        maxFaceForNoLabs: 1e6,
        minAge: 18,
        maxAge: 64,
        maxAgeForHigherTerm: 49,
        maxAgeForHigherFace: 60,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium',
        tableRatingsEnabled: true,
        faceIncrement: 5e4,
        term: [10, 15, 20, 30],
        restrictedTerm: 30,
        availableFaceAmountOptions: (function () {
            var options = [];
            for (var face = 1e5; face <= 3e6; face += 5e4) {
                options.push(face);
            }
            return options;
        })()
    },
    ValoraTerm: {
        minFace: 1e5,
        maxFace: 1e6,
        minAge: 18,
        maxAge: 44,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: ''
    },
    ValoraROP: {
        minFace: 1e5,
        maxFace: 1e6,
        minAge: 18,
        maxAge: 44,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'ROP Rider'
    },
    CASTerm: {
        minFace: 1e5,
        maxFace: 3e6,
        maxFaceForTLIC: 1e6,
        maxFaceForInstant: 1e6,
        maxFaceForHigherAge: 1e6,
        maxAgeForHigherFace: 59.5,
        maxFaceForNoncitizens: 0,
        maxFaceForAlgoGate: 3e6,
        minTerm: 10,
        minAge: cpTermMinAge,
        maxAge: 65,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        termBreakdown: {
            1: {
                maxAge: 65
            },
            10: {
                maxAge: 65
            },
            15: {
                maxAge: 65
            },
            20: {
                maxAge: 65
            },
            25: {
                maxAge: 60,
                tobaccoMaxAge: 55
            },
            30: {
                maxAge: 55,
                tobaccoMaxAge: 50
            }
        }
    },
    CASTermECP: {
        minFace: 1e5,
        maxFace: 3e6,
        maxFaceForTLIC: 1e6,
        maxFaceForInstant: 1e6,
        maxFaceForNoncitizens: 0,
        maxFaceForAlgoGate: 3e6,
        minAge: cpTermMinAge,
        maxAge: 54,
        minTerm: 15,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        termBreakdown: {
            15: {
                maxAge: 54
            },
            20: {
                maxAge: 54
            },
            25: {
                maxAge: 54
            },
            30: {
                maxAge: 54,
                tobaccoMaxAge: 44
            }
        }
    },
    CPL100: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        maxAgeForHigherFace: 59.5,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 100,
        termBreakdown: {
            100: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    CPL100A: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForNoncitizens: 1e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        maxAgeForHigherFace: 59.5,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 100,
        termBreakdown: {
            100: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    CPL65: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForNoncitizens: 1e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 50,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 65,
        termBreakdown: {
            65: [
                {
                    faceUpTo: 1e6,
                    maxAge: 50
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 50
                }
            ]
        }
    },
    CPL65A: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForNoncitizens: 1e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 50,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 65,
        termBreakdown: {
            65: [
                {
                    faceUpTo: 1e6,
                    maxAge: 50
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 50
                }
            ]
        }
    },
    CPL10: {
        minFace: 1e5,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 10,
        termBreakdown: {
            10: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    CPL10A: {
        minFace: 1e5,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 10,
        termBreakdown: {
            10: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    CPL12: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 12,
        termBreakdown: {
            12: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    CPL15: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 15,
        termBreakdown: {
            15: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    CPL15A: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 15,
        termBreakdown: {
            15: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    CPL20: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 20,
        termBreakdown: {
            20: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    CPL20A: {
        minFace: 25e3,
        maxFace: 3e6,
        maxFaceForInstant: 1e6,
        maxFaceForAlgoGate: 3e6,
        maxFaceForHigherAge: 1e6,
        minAge: 0,
        maxAge: 65,
        flatExtraMax: 5,
        temporaryFlatExtra: false,
        availableRiders: 'Waiver of Premium, Convertibility',
        tableRatingsEnabled: true,
        term: 20,
        termBreakdown: {
            20: [
                {
                    faceUpTo: 1e6,
                    maxAge: 65
                },
                {
                    faceUpTo: 3e6,
                    maxAge: 59.5
                }
            ]
        }
    },
    ET10: {
        lifeBridgeNotificationIncomeMin: 10e3,
        lifeBridgeNotificationIncomeMax: 40e3
    },
    ET03: {
        lifeBridgeNotificationIncomeMin: 10e3,
        lifeBridgeNotificationIncomeMax: 40e3
    },
    AllProductAge: {
        minAge: 0,
        minTermAge: cpTermMinAge,
        maxAge: 65,
        maxAgeForHigherFace: 59.5,
        maxFaceForNonCitizens: 1e6,
    }
};
var quoteEngineKeys = {
    Haven: {
        quoteKey: 'HavenTerm',
        waiverKey: 'HavenTerm'
    },
    HavenTermSI: {
        quoteKey: 'HavenTermSI',
        waiverKey: 'HavenTermSI'
    },
    HavenTermSIT: {
        quoteKey: 'HavenTermSIT',
        waiverKey: 'HavenTermSIT'
    },
    HavenDI: {
        quoteKey: 'HavenDI',
        waiverKey: 'HavenDI'
    },
    ValoraTerm: {
        quoteKey: 'ValoraTerm',
        waiverKey: 'HavenTerm'
    },
    ValoraROP: {
        quoteKey: 'ValoraROP',
        waiverKey: 'HavenTerm'
    },
    CASTerm: {
        quoteKey: 'CASTerm',
        waiverKey: 'CASTerm'
    },
    CASTermECP: {
        quoteKey: 'CASTermECP',
        waiverKey: 'CASTermECP'
    },
    CPL100: {
        quoteKey: 'CPL100',
        waiverKey: 'CPL100'
    },
    CPL100A: {
        quoteKey: 'CPL100A',
        waiverKey: 'CPL100A'
    },
    CPL65: {
        quoteKey: 'CPL65',
        waiverKey: 'CPL65'
    },
    CPL65A: {
        quoteKey: 'CPL65A',
        waiverKey: 'CPL65A'
    },
    CPL10: {
        quoteKey: 'CPL10',
        waiverKey: 'CPL10'
    },
    CPL10A: {
        quoteKey: 'CPL10A',
        waiverKey: 'CPL10A'
    },
    CPL12: {
        quoteKey: 'CPL12',
        waiverKey: 'CPL12'
    },
    CPL15: {
        quoteKey: 'CPL15',
        waiverKey: 'CPL15'
    },
    CPL15A: {
        quoteKey: 'CPL15A',
        waiverKey: 'CPL15A'
    },
    CPL20: {
        quoteKey: 'CPL20',
        waiverKey: 'CPL20'
    },
    CPL20A: {
        quoteKey: 'CPL20A',
        waiverKey: 'CPL20A'
    },
    MMDirectTerm: {
        quoteKey: 'MMDirectTerm',
        waiverKey: 'MMDirectTerm'
    },
    MMDirectTermECP: {
        quoteKey: 'MMDirectTermECP',
        waiverKey: 'MMDirectTermECP'
    },
    ET10: {
        quoteKey: 'ET10',
        waiverKey: 'ET10'
    },
    ET03: {
        quoteKey: 'ET03',
        waiverKey: 'ET03'
    }
};
var platforms = {
    Coverpath: {
        channels: [channels.CAS.code, channels.MMDirect.code, channels.LifeBridge.code]
    }
};
var products = {
    HavenTerm: {
        code: 'HavenTerm',
        name: 'Haven Term',
        type: exports.productTypes.Term,
        channel: channels.Haven,
        policyRange: policyRanges.HavenTerm,
        quoteKey: quoteEngineKeys.Haven,
        convertible: false,
        productSpecs: exports.productSpecs.HavenTerm
    },
    HavenTermSI: {
        code: 'HavenTermSI',
        name: 'Haven Term Simplified',
        type: exports.productTypes.Term,
        channel: channels.Haven,
        policyRange: policyRanges.HavenTermSI,
        quoteKey: quoteEngineKeys.HavenTermSI,
        convertible: false,
        productSpecs: exports.productSpecs.HavenTermSI,
        stateGroupCode: 'SI'
    },
    ValoraTerm: {
        code: 'ValoraTerm',
        name: 'ValoraLife Term',
        type: {
            name: exports.productTypes.Term.name,
            group: productGroups.LIFE.name,
            code: 'Term',
            productCodes: {
                ValoraTerm: 'ValoraTerm'
            }
        },
        channel: channels.Valora,
        policyRange: policyRanges.ValoraTerm,
        quoteKey: quoteEngineKeys.ValoraTerm,
        convertible: false,
        productSpecs: exports.productSpecs.ValoraTerm
    },
    ValoraROP: {
        code: 'ValoraROP',
        name: 'ValoraLife Term Plus',
        type: exports.productTypes.ROP,
        channel: channels.Valora,
        policyRange: policyRanges.ValoraROP,
        quoteKey: quoteEngineKeys.ValoraROP,
        convertible: false,
        productSpecs: exports.productSpecs.ValoraROP
    },
    CASTerm: {
        artDescription: 'Annually Renewable Term',
        code: 'CASTerm',
        name: 'MassMutual Convertible Term',
        type: exports.productTypes.Term,
        channel: channels.CAS,
        policyRange: policyRanges.CASTerm,
        quoteKey: quoteEngineKeys.CASTerm,
        convertible: true,
        productSpecs: exports.productSpecs.CASTerm
    },
    CASTermECP: {
        code: 'CASTermECP',
        name: 'MassMutual Convertible Term',
        type: exports.productTypes.Term,
        channel: channels.CAS,
        policyRange: policyRanges.CASTermECP,
        quoteKey: quoteEngineKeys.CASTermECP,
        convertible: true,
        productSpecs: exports.productSpecs.CASTermECP
    },
    CPL100: {
        code: 'CPL100',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL100,
        quoteKey: quoteEngineKeys.CPL100,
        convertible: true,
        productSpecs: exports.productSpecs.CPL100
    },
    CPL100A: {
        code: 'CPL100A',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL100,
        quoteKey: quoteEngineKeys.CPL100A,
        convertible: true,
        productSpecs: exports.productSpecs.CPL100A,
        shortName: "WL $Term$",
        longName: "Whole Life $Term$"
    },
    CPL65: {
        code: 'CPL65',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL65,
        quoteKey: quoteEngineKeys.CPL65,
        convertible: true,
        productSpecs: exports.productSpecs.CPL65
    },
    CPL65A: {
        code: 'CPL65A',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL65,
        quoteKey: quoteEngineKeys.CPL65A,
        convertible: true,
        productSpecs: exports.productSpecs.CPL65A
    },
    CPL10: {
        code: 'CPL10',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL10,
        quoteKey: quoteEngineKeys.CPL10,
        convertible: true,
        productSpecs: exports.productSpecs.CPL10
    },
    CPL10A: {
        code: 'CPL10A',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL10,
        quoteKey: quoteEngineKeys.CPL10A,
        convertible: true,
        productSpecs: exports.productSpecs.CPL10A
    },
    CPL12: {
        code: 'CPL12',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL12,
        quoteKey: quoteEngineKeys.CPL12,
        convertible: true,
        productSpecs: exports.productSpecs.CPL12
    },
    CPL15: {
        code: 'CPL15',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL15,
        quoteKey: quoteEngineKeys.CPL15,
        convertible: true,
        productSpecs: exports.productSpecs.CPL15
    },
    CPL15A: {
        code: 'CPL15A',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL15,
        quoteKey: quoteEngineKeys.CPL15A,
        convertible: true,
        productSpecs: exports.productSpecs.CPL15A
    },
    CPL20: {
        code: 'CPL20',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL20,
        quoteKey: quoteEngineKeys.CPL20,
        convertible: true,
        productSpecs: exports.productSpecs.CPL20
    },
    CPL20A: {
        code: 'CPL20A',
        name: 'MassMutual Whole Life',
        type: exports.productTypes.Whole,
        channel: channels.CAS,
        policyRange: policyRanges.CPL20,
        quoteKey: quoteEngineKeys.CPL20A,
        convertible: true,
        productSpecs: exports.productSpecs.CPL20A
    },
    MMDirectTerm: {
        code: 'MMDirectTerm',
        name: 'MassMutual Direct Term',
        type: exports.productTypes.Term,
        channel: channels.MMDirect,
        policyRange: policyRanges.MMDirectTerm,
        quoteKey: quoteEngineKeys.MMDirectTerm,
        convertible: true,
        productSpecs: exports.productSpecs.CASTerm
    },
    MMDirectTermECP: {
        code: 'MMDirectTermECP',
        name: 'MassMutual Direct Term',
        type: exports.productTypes.Term,
        channel: channels.MMDirect,
        policyRange: policyRanges.MMDirectTermECP,
        quoteKey: quoteEngineKeys.MMDirectTermECP,
        convertible: true,
        productSpecs: exports.productSpecs.CASTermECP
    },
    ET10: {
        code: 'ET10',
        name: 'LifeBridge',
        type: exports.productTypes.Term,
        channel: channels.LifeBridge,
        policyRange: policyRanges.ET10,
        quoteKey: quoteEngineKeys.ET10,
        convertible: true,
        productSpecs: exports.productSpecs.CASTermECP
    },
    ET03: {
        code: 'ET03',
        name: 'Healthbridge',
        type: exports.productTypes.Term,
        channel: channels.HealthBridge,
        policyRange: policyRanges.ET03,
        quoteKey: quoteEngineKeys.ET03,
        convertible: true,
        productSpecs: exports.productSpecs.CASTermECP
    },
    RMMTerm: {
        name: 'RMM Term',
        type: exports.productTypes.Term,
        channel: channels.RMM,
        policyRange: policyRanges.RMMTerm,
        quoteKey: {
            quoteKey: 'RMMTerm',
            waiverKey: 'RMMTerm'
        },
        convertible: false,
        productSpecs: {
            minFace: 1e5,
            maxFace: 1e6,
            minAge: 18,
            maxAge: 65,
            flatExtraMax: 5,
            availableRiders: 'Waiver of Premium'
        },
        code: 'RMMTerm'
    }
};
var product = {
    branding: branding,
    carrier: carrier,
    productGroups: productGroups,
    productTypes: exports.productTypes,
    channelGroups: channelGroups,
    channels: channels,
    policyRanges: policyRanges,
    productSpecs: exports.productSpecs,
    quoteEngineKeys: quoteEngineKeys,
    products: products,
    productCodes: productCodes,
    platforms: platforms
};
function key(data) {
    _.each(data, function (element, key) {
        element.code = key;
    });
}
// TODO is this necessary?
key(product.products);
key(branding);
key(carrier);
key(channels);
key(exports.productTypes);
_.each(exports.productTypes, function (type) {
    _.each(products, function (product, key) {
        if (product.type.code === type.code) {
            type.productCodes[key] = product.code;
        }
    });
});
_.each(channels, function (channel) {
    _.each(products, function (product, key) {
        if (product.channel.code === channel.code) {
            channel.productCodes[key] = product.code;
        }
    });
});
_.each(channels, function (channel) {
    _.each(exports.productTypes, function (type, typeKey) {
        _.each(products, function (product, productKey) {
            if (product.type.code === type.code && product.channel.code === channel.code) {
                channel.productTypes[typeKey] = channel.productTypes[typeKey] || _.clone(type);
                channel.productTypes[typeKey].productCodes[productKey] = product.code;
            }
        });
    });
});
exports.Product = product;
exports.TimeFrequency = {
    annual: 'year',
    monthly: 'month'
};
exports.FrequencyUnit = {
    Annual: 'yr',
    Monthly: 'mo'
};
/**
 * only certain properties affect the waiver of premium amount
 */
exports.PropertiesForWoP = [
    'gender',
    'dob',
    'waiver',
    'state',
    'term',
    'faceAmount',
    'paymentFrequency',
    'termDisplay',
    'hasGirRider',
    'girRiderAmount',
    'hasRtrRider',
    'rtrRiderAmount',
    'hasEcp'
];
exports.PropertiesForECP = ['dob', 'term'];
var RiderType;
(function (RiderType) {
    RiderType["WOP"] = "Waiver of Premium";
    RiderType["CONVERTIBILITY"] = "Convertibility";
    RiderType["GIR"] = "GIR";
    RiderType["RTR"] = "RTR";
})(RiderType = exports.RiderType || (exports.RiderType = {}));
var BenefitType;
(function (BenefitType) {
    BenefitType["Death"] = "Death";
    BenefitType["Waiver"] = "Waiver";
    BenefitType["GIR"] = "GIR";
    BenefitType["RTR"] = "RTR";
})(BenefitType = exports.BenefitType || (exports.BenefitType = {}));
exports.RiderConstants = {
    wop: {
        minAge: cpTermMinAge,
        maxAge: 59.5
    },
    gir: {
        minFace: 25e3,
        maxFace: 125e3,
        maxAge: 40
    },
    rtr: {
        minFace: 1e5,
        maxFace: 3e6,
        maxFaceForNoncitizens: 1e6,
        ageLimits: {
            default: {
                // currently CPL100, CPL10, CPL10A, CP12, CPL15, CPL20
                faceAmountSlabs: [
                    {
                        minAge: 17.5,
                        maxAge: 65,
                        faceUpTo: 1e6
                    },
                    {
                        minAge: 17.5,
                        maxAge: 59.5,
                        faceUpTo: 3e6
                    }
                ]
            },
            CPL65: {
                // override
                faceAmountSlabs: [
                    {
                        faceUpTo: 1e6,
                        minAge: 17.5,
                        maxAge: 50 //exclusive
                    },
                    {
                        faceUpTo: 3e6,
                        minAge: 17.5,
                        maxAge: 50 //exclusive
                    }
                ]
            }
        }
    },
    alir: {
        totalFaceCapUsCitizens: 3e6,
        totalFaceCapForNonUsCitizens: 1e6,
        minAnnualScheduledAmount: 300,
        minAnnualUnscheduledAmount: 1,
        maxAnnualScheduledAmount: 5e6,
        maxAnnualUnscheduledAmount: 3e6,
        narFactors: [
            {
                totalFaceUpTo: 250e3,
                ageSlabs: [
                    // maxAge is inclusive
                    {
                        maxAge: 30,
                        scheduled: 20,
                        unscheduled: 4
                    },
                    {
                        maxAge: 40,
                        scheduled: 10,
                        unscheduled: 3
                    },
                    {
                        maxAge: 59,
                        scheduled: 5,
                        unscheduled: 2
                    },
                    {
                        maxAge: Infinity,
                        scheduled: 1,
                        unscheduled: 1
                    }
                ]
            },
            {
                totalFaceUpTo: Infinity,
                ageSlabs: [
                    // maxAge is inclusive
                    {
                        maxAge: 30,
                        scheduled: 10,
                        unscheduled: 4
                    },
                    {
                        maxAge: 40,
                        scheduled: 10,
                        unscheduled: 3
                    },
                    {
                        maxAge: 59,
                        scheduled: 5,
                        unscheduled: 2
                    },
                    {
                        maxAge: Infinity,
                        scheduled: 1,
                        unscheduled: 1
                    }
                ]
            }
        ],
        plannedYears: {
            min: 1
        }
    },
    cir: {
        minAge: 18,
        maxAge: 79,
        minBaseBenefitPool: 75000,
        maxBaseBenefitPool: 500000,
        baseFaceAmountForErrorCheck: 250000,
        minFaceAmount: 100000,
        lowFaceAmountCIRMax: 25000,
        highFaceAmountCIRMaxPercent: 0.9,
        predictedBenefitAgeMaxAge: 120
    }
};
exports.LowFaceWholeLife = {
    minFace: 25e3,
    maxFace: 50e3,
    availableProducts: ['CPL100', 'CPL65', 'CPL20', 'CPL15', 'CPL12']
};
